import React from 'react';

// Components
import { Button } from '@capintel/component-lib/button';
import FormattedMessageV2 from '@/views/components/i18n/FormattedMessageV2';

// Libraries
import { useSelector } from 'react-redux';

// Types
import HistoricalScenario from '@/types/historical-scenario';
import { ReduxState } from '@/redux/modules/types';
import { UUID } from '@/types/global';

// Utils
import { formatMessage, FormattedHTMLMessage } from '@/utils/i18n';

interface DeleteBodyProps {
  customScenario: HistoricalScenario;
  i18nBasePath: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: (id: UUID) => void;
}

export const DeleteBody = ({ customScenario, i18nBasePath, isLoading = false, onClose, onConfirm }: DeleteBodyProps) => {
  const locale = useSelector((state: ReduxState) => state.intl.locale);

  const handleOnConfirm = () => {
    onConfirm(customScenario._id);
  };

  return (
    <>
      <div className="delete-body confirmation-modal-content">
        <div className="confirmation-modal-description">
          <FormattedHTMLMessage
            id={`${i18nBasePath}.Description1`}
            values={{ name: customScenario.name[locale] || formatMessage(`${i18nBasePath}.Description1Fallback`) }}
          />
        </div>
        <FormattedMessageV2 className="confirmation-modal-description" toLocalize={`${i18nBasePath}.Description2`} />
        <FormattedMessageV2 className="confirmation-modal-description" toLocalize={`${i18nBasePath}.Description3`} />
      </div>
      <div className="confirmation-modal-footer">
        <Button variant="secondary" onClick={onClose}>
          {formatMessage(`${i18nBasePath}.Cancel`)}
        </Button>
        <Button variant="destructive" onClick={handleOnConfirm} loading={isLoading}>
          {formatMessage(`${i18nBasePath}.Destructive`)}
        </Button>
      </div>
    </>
  );
};
